"use client";

import type { ReactNode } from "react";
import { HoverPrefetchLink } from "@/components/ui/hover-prefetch-link";
import { ArrowRight } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { NavLinkItem, NavMenu } from "./types";

function NavLinkButton({
  link,
  isActive,
  onLinkSelect,
  variant = "quiet",
  children,
}: {
  link: NavLinkItem;
  isActive: (href: string) => boolean;
  onLinkSelect: () => void;
  variant?: "quiet" | "link";
  children?: ReactNode;
}) {
  return (
    <Button
      asChild
      variant={variant}
      onClick={onLinkSelect}
      className="w-full justify-start"
    >
      <HoverPrefetchLink
        href={link.href}
        aria-current={isActive(link.href) ? "page" : undefined}
      >
        {link.label}
        {children}
      </HoverPrefetchLink>
    </Button>
  );
}

export function NavMenuLinks({
  menu,
  isActive,
  onLinkSelect,
  columns = 1,
}: {
  menu: NavMenu;
  isActive: (href: string) => boolean;
  onLinkSelect: () => void;
  columns?: 1 | 2;
}) {
  return (
    <div className="flex flex-col">
      {menu.hub && (
        <div className="mb-1 border-b border-border pb-1">
          <NavLinkButton
            link={menu.hub}
            isActive={isActive}
            onLinkSelect={onLinkSelect}
            variant="link"
          >
            <ArrowRight className="size-4" aria-hidden />
          </NavLinkButton>
        </div>
      )}
      <ul className={cn("grid", columns === 2 ? "grid-cols-2 gap-x-2" : "grid-cols-1")}>
        {menu.links.map((link) => (
          <li key={link.href}>
            <NavLinkButton
              link={link}
              isActive={isActive}
              onLinkSelect={onLinkSelect}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
